import React from 'react'
import styled from '@emotion/styled'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { ClearingHouseInteraction } from 'api'
import { Locale, Translation } from 'locale'
import { ClearingHouseInteractionDialog } from './ClearingHouseInteractionDialog'

interface ClearingHouseInteractionViewButtonProps extends ModalConsumerProps {
  clearingHouseInteraction: ClearingHouseInteraction
}

const ViewButton = styled(TextButton)`
  min-width: 50px;
`

class ClearingHouseInteractionViewButtonComponent extends React.Component<ClearingHouseInteractionViewButtonProps> {
  render() {
    return (
      <ViewButton type={TextButtonType.Tertiary} onClick={() => this.onClick()}>
        {Locale.translate(Translation.TC_VIEW_INTERACTION_DETAILS)}
      </ViewButton>
    )
  }

  onClick() {
    const { clearingHouseInteraction, showModal } = this.props
    showModal(<ClearingHouseInteractionDialog clearingHouseInteraction={clearingHouseInteraction} />)
  }
}

export const ClearingHouseInteractionViewButton = withModal(ClearingHouseInteractionViewButtonComponent)
